import React, { useState } from 'react'
import { connect } from 'react-redux'
import { getAllTerminalsAction, activeTerminalAction } from '../../../actions/admin/adminTerminals'
import { AdminUI } from '../../../constants/admin/adminUi'
import { AppState } from '../../../reducers'
import './terminals.less'
import { setAdminUIAction } from '../../../actions/admin/adminUi'

const id = 'id'
const info = 'info'
const location = 'location'
const state = 'state'

const mapStateToProps = (state: AppState) => ({
  terminals: state.adminTerminals.terminals,
})

const mapDispatchToProps = {
  getAllTerminals: getAllTerminalsAction,
  setAdminUI: setAdminUIAction,
  activeTerminal: activeTerminalAction,
}

type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const Component: React.FC<Props> = ({ terminals, setAdminUI, activeTerminal }: Props) => {
  const [filterId, setFilterId] = useState()
  const [filterInfo, setFilterInfo] = useState()
  const [filterLocation, setFilterLocation] = useState()
  const [filterState, setFilterState] = useState()

  const filteredTerminals = () => {
    let filtered = [...terminals]
    if (filterId) {
      filtered = filtered.filter((item: any) => {
        return item[id].toLowerCase().includes(filterId)
      })
    }

    if (filterInfo) {
      filtered = filtered.filter((item: any) => {
        return item[info].toLowerCase().includes(filterInfo)
      })
    }

    if (filterLocation) {
      filtered = filtered.filter((item: any) => {
        return item[location].toLowerCase().includes(filterLocation)
      })
    }

    if (filterState) {
      filtered = filtered.filter((item: any) => {
        return item[state].toLowerCase().includes(filterState)
      })
    }
    return filtered
  }

  const selectTerminal = (item: any) => {
    activeTerminal(item)
    setAdminUI(AdminUI.TERMINAL)
  }

  return (
    <div className="admin-all-terminals-main">
      <div className="admin-all-terminals-table">
        <div className="admin-all-terminals-table-header">
          <div className="header-cell column-id">
            <div className="header-cell-inner">
              <div className="label">id</div>
              <div className="header-input-field">
                <input className="input-filter" value={filterId} onChange={(e) => setFilterId(e.target.value)}></input>
                <div className="magnifying"></div>
              </div>
            </div>
          </div>
          <div className="header-cell column-info">
            <div className="header-cell-inner">
              <div className="label">info</div>
              <div className="header-input-field">
                <input
                  className="input-filter"
                  value={filterInfo}
                  onChange={(e) => setFilterInfo(e.target.value)}
                ></input>
                <div className="magnifying"></div>
              </div>
            </div>
          </div>
          <div className="header-cell column-location">
            <div className="header-cell-inner">
              <div className="label">location</div>
              <div className="header-input-field">
                <input
                  className="input-filter"
                  value={filterLocation}
                  onChange={(e) => setFilterLocation(e.target.value)}
                ></input>
                <div className="magnifying"></div>
              </div>
            </div>
          </div>
          <div className="header-cell column-state">
            <div className="header-cell-inner">
              <div className="label">state</div>
              <div className="header-input-field">
                <input
                  className="input-filter"
                  value={filterState}
                  onChange={(e) => setFilterState(e.target.value)}
                ></input>
                <div className="magnifying"></div>
              </div>
            </div>
          </div>
          <div className="header-cell column-space"> </div>
        </div>
        <div className="terminals-all-rows">
          {filteredTerminals().map((item: any, index: number) => (
            <div key={'row' + index} className="admin-all-terminals-table-row">
              <div key={'id' + index} className="table-cell border-right column-id">
                <div className="table-cell-inner">{item.id}</div>
              </div>
              <div key={'info' + index} className="table-cell border-right column-info">
                <div className="table-cell-inner">{item.info}</div>
              </div>
              <div key={'location' + index} className="table-cell border-right column-location">
                <div className="table-cell-inner">{item.location}</div>
              </div>
              <div key={'state' + index} className="table-cell border-right column-state">
                <div className="table-cell-inner"> {item.state}</div>
              </div>
              <div key={'button' + index} className="admin-all-terminals-table-row-button column-space">
                <button className="admin-all-terminals-edit-button" onClick={() => selectTerminal(item)}>
                  &#x270E;
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
